// extracted by mini-css-extract-plugin
export default {"main_box":"HotelsPage_main_box__4qK5x"};